import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { segmentedNav } from 'ngx-bootstrap-icons';
import { Subscription } from 'rxjs/internal/Subscription';
import { CustomTracker } from 'src/app/data/dietitian/domain/custom_tracker/custom_tracker';

import { LoadingStatus } from '../../../../../../core/domain/events/state_provider';
import { Dietitian } from '../../../../../../data/dietitian/domain/dietitian';
import { DiaryType } from '../../../../../../data/tracker/domain/diary_type/diary_type';
import { ConfirmationModalComponent } from '../../../../../components/confirmation-modal/confirmation-modal.component';
import { CustomTrackersListFacade } from './custom-trackers-list.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-custom-trackers-list',
  templateUrl: './custom-trackers-list.component.html',
  styleUrls: ['./custom-trackers-list.component.scss'],
  providers: [CustomTrackersListFacade],
})
export class CustomTrackersListComponent implements OnInit {
  public currentDietitian?: Dietitian;
  public dietitianStateSub: Subscription;
  public diaryTypes: DiaryType[];
  public customTrackers: CustomTracker[] = [];
  public customTrackerEventSub: Subscription;
  public isLoading = true;
  public error?: string;
  public bsModalRef?: BsModalRef;
  public customTrackerAction?: CustomTracker;

  constructor(
    private facade: CustomTrackersListFacade,
    private modalService: BsModalService,
  ) {
    this.facade
      .findAllDiaryTypes()
      .then((diaryTypes) => (this.diaryTypes = diaryTypes));
  }

  ngOnInit(): void {
    this.dietitianStateSub = this.facade.dietitianState$.subscribe((state) => {
      this.currentDietitian = state.entity;

      switch (state.loading) {
        case LoadingStatus.LOADING:
          this.isLoading = true;
          break;
        case LoadingStatus.ERROR:
          this.error = state.message;
          this.isLoading = false;
          break;
        case LoadingStatus.COMPLETE:
          this.loadCustomTrackers().then();
          break;
      }
    });

    this.customTrackerEventSub = this.facade.customTrackerEvent$.subscribe(
      () => {
        this.loadCustomTrackers().then();
      },
    );
  }

  deleteCustomTrackerConfirmation(customTracker: CustomTracker) {
    const initialState: ModalOptions = {
      class: 'modal-md modal-dialog-centered',
      initialState: {
        title: 'Supprimer ce tracker personnalisé ?',
        subtitle: 'Attention, il sera supprimé sur tous vos patients.',
      },
    };
    this.bsModalRef = this.modalService.show(
      ConfirmationModalComponent,
      initialState,
    );
    if (this.bsModalRef.content instanceof ConfirmationModalComponent) {
      this.bsModalRef.content.validate.subscribe(() => {
        this.deleteCustomTracker(customTracker).then();
      });
    }
  }

  async deleteCustomTracker(customTracker: CustomTracker) {
    if (!customTracker || !this.currentDietitian) {
      return;
    }

    this.customTrackerAction = customTracker;
    await this.facade.deleteCustomTracker(
      this.currentDietitian.dietitianId?.id?.toString(),
      customTracker.customTrackerId?.id?.toString(),
    );
    this.customTrackerAction = undefined;
    this.loadCustomTrackers().then();
  }

  async loadCustomTrackers() {
    this.isLoading = true;
    this.error = undefined;
    try {
      if (this.currentDietitian != null) {
        this.customTrackers = await this.facade.getDietitianCustomTrackers(
          this.currentDietitian?.id.toString(),
        );
      } else {
        this.customTrackers = [];
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        this.error = error.message;
      }
    }
    this.isLoading = false;
  }

  ngOnDestroy(): void {
    this.dietitianStateSub?.unsubscribe();
  }

  protected readonly segmentedNav = segmentedNav;
}
